function createTooltip(text, top, left, width, height) {
  const tooltip = document.createElement('span');
  tooltip.className = 'art-tooltip-wrap';
  tooltip.innerHTML = `<span class="art-tooltip"><span class="art-tooltip-inner">${text}</span></span>`;
  tooltip.style.cssText = `top: ${top}px; left: ${left}px; width: ${width}px; height: ${height}px;`;

  return tooltip;
}

export function tooltipShow(e) {
  const el = e.target;

  const pt = parseInt(getComputedStyle(el)['padding-top'], 10);
  const pb = parseInt(getComputedStyle(el)['padding-bottom'], 10);
  const width = el.clientWidth;
  const height = el.clientHeight - pt - pb;
  const top = height - 60;
  const left = -5;

  const tooltip = createTooltip(el.dataset.tooltip, top, left, width, height);
  el.appendChild(tooltip);
}

export function tooltipHide() {
  Array.from(
    document.getElementsByClassName('art-tooltip-wrap'),
  ).forEach((el) => {
    el.remove();
  });
}



// WEBPACK FOOTER //
// ./src/helpers/tooltips.js